import { defaulLangTextValidation, defaultTTranslate, MEASURE, SORTING_DIRECTION } from 'src/constants/main';
import {
  IModifier,
  IModifierOption,
  IModifiersFilters,
  IModifierValidation,
  MODIFIERS_COLUMN_NAME,
} from 'src/view/screens/MenuManagementScreen/screens/ModifiersScreen/types/modifiers';

export const defaultModifier: IModifier = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  status: 1,
  is_delete: 0,
  options: [],
  is_draft: true,
};

export const defaultModifierOption: IModifierOption = {
  id: 0,
  external_id: '',
  name: defaultTTranslate,
  price: '',
  calories: null,
  weight: '',
  unit: MEASURE.NULL,
  taxable: 1,
  is_delete: 0,
};

export const defaultModifiersFilters: IModifiersFilters = {
  search: '',
  availability: undefined,
  sort_field: MODIFIERS_COLUMN_NAME.NAME,
  sort_dir: SORTING_DIRECTION.ASCENDING,
};

export const defaultModifierValidation: IModifierValidation = {
  valid: true,
  name: defaulLangTextValidation,
  options: [],
};
